import React from "react";

export default class Alcohol extends React.Component {
  render() {
    return (
      <div className="healthcheck">
        <h2>하단의 음주측정기에서 음주측정을 해주세요</h2>
        <div className="healthcheck-container">
          <div className="healthcheck-tb">
            <div className="healthcheck-td" id="s-cover">
              <div className="healthcheck-button">
                <img
                  src="https://img.icons8.com/cotton/64/000000/whiskey.png"
                  alt="음주"
                />
              </div>
            </div>
            <div className="healthcheck-td">
              <input
                type="text"
                placeholder="음주"
                name="alcohol"
                required
                // readOnly
                defaultValue="0.02"
                onChange={this.props.change}
              />
            </div>
            <div className="healthcheck-td">
              <p>%</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
